(ns frontend.ux-overhaul.nev.events
  (:require
   [frontend.actions.account :as account-actions]
   [frontend.routing :as routing]
   [re-frame.core :as rf]))




(defn set-new-nev-enabled!
  [enabled?]
  (let [data {:path      [:new-nev-in-use?]
              :new-value enabled?}]
    (account-actions/*->update-view-config
     data
     (fn [] (js/console.log "Updated view config success!"))
     (fn [] (js/console.log "Failure updating view config!")))))


;; re frame

(rf/reg-event-fx
 ::open-view-configuration
 (fn [{:keys [db]} [_ previous-page]]
   (let [new-db (assoc db :previous-page previous-page)]
     {:db new-db
      ::routing/old-routing {:path-args [:nev-view-configuration]}})))


(rf/reg-event-fx
 ::close-view-configuration
 (fn [{:keys [db]} args]
   (let [previous-page (:previous-page db)
         view-id (:view-id previous-page)
         entity-id (-> previous-page
                       :route-params
                       :id
                       (js/parseInt))]
     (merge
      {:db db
       ::routing/old-routing {:path-args [view-id :id entity-id]}}))))
